import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const SmsText = {
	name: NAME,
	apiProvider,
	router,
};
